/*
https://vuex.vuejs.org/guide/
https://markus.oberlehner.net/blog/combining-graphql-and-vuex/
https://github.com/vuejs/vuex/tree/dev/examples
*/

import worlds from "./worlds.js";
import players from "./players.js";
import quests from "./quests.js";
import questEfforts from "./questEfforts.js";
import questRanks from "./questRanks.js";
import rides from "./rides.js";

export default {
  namespaced: true,
  modules: {
    players: players,
    worlds: worlds,
    quests: quests,
    questEfforts: questEfforts,
    questRanks: questRanks,
    rides: rides,
  },
};